import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.0_@emnapi+core@1.5.0_@emnapi+runtime@1.5.0_@netlify+blobs@9.1.2_@types+node@2_c0aef0fd05637f3cd51588055b816b76/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.20.0_@emnapi+core@1.5.0_@emnapi+runtime@1.5.0_@netlify+blobs@9.1.2_@types+node@2_c0aef0fd05637f3cd51588055b816b76/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts"),
  "pos-auth": () => import("/opt/buildhome/repo/middleware/pos-auth.ts"),
  "super-admin": () => import("/opt/buildhome/repo/middleware/super-admin.ts")
}